module.exports = __webpack_public_path__ + "media/img/vca/categories/yacht-0d308f5c3c28a2ec9281a29294b2027e.png";